// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CUSTOM_FIELD_TYPES () {
        return CUSTOM_FIELD_TYPES;
    },
    get CustomFieldIntegration () {
        return CustomFieldIntegration;
    },
    get CustomFieldModel () {
        return CustomFieldModel;
    },
    get CustomFieldTypes () {
        return CustomFieldTypes;
    },
    get CustomFieldUserClass () {
        return CustomFieldUserClass;
    },
    get CustomValueModel () {
        return CustomValueModel;
    },
    get DEFAULT_COMPANY_CUSTOM_FIELDS () {
        return DEFAULT_COMPANY_CUSTOM_FIELDS;
    },
    get FieldValueModel () {
        return FieldValueModel;
    },
    get STANDARD_CUSTOM_FIELDS () {
        return STANDARD_CUSTOM_FIELDS;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const STANDARD_CUSTOM_FIELDS = [
    {
        name: "First Name",
        type: "text"
    },
    {
        name: "Last Name",
        type: "text"
    },
    {
        name: "Nickname",
        type: "text"
    },
    {
        name: "Email",
        type: "email"
    },
    {
        name: "Phone Number",
        type: "phone"
    },
    {
        name: "Manager",
        type: "person"
    },
    {
        name: "Job Title",
        type: "text"
    },
    {
        name: "Hire Date",
        type: "date"
    },
    {
        name: "Termination Date",
        type: "date"
    },
    {
        name: "Group",
        type: "department"
    },
    {
        name: "Activation Status",
        type: "single-select",
        options: [
            "Active",
            "Deactivated"
        ]
    },
    {
        name: "Contributors",
        type: "people"
    },
    {
        name: "Login Status",
        type: "single-select",
        options: [
            "Signed in",
            "Invited/ not signed in",
            "Not invited/ not signed in"
        ]
    },
    {
        name: "Salary",
        type: "salary"
    },
    {
        name: "Role",
        type: "role"
    }
];
const DEFAULT_COMPANY_CUSTOM_FIELDS = [
    {
        name: "Activation Status",
        type: "single-select",
        edit: [
            "admin"
        ],
        vis: [],
        options: [
            "Active",
            "Deactivated"
        ],
        order: -1,
        std: true
    },
    {
        name: "First Name",
        type: "text",
        edit: [
            "self",
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 0,
        std: true
    },
    {
        name: "Nickname",
        type: "text",
        edit: [
            "self",
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 1,
        std: true
    },
    {
        name: "Last Name",
        type: "text",
        edit: [
            "self",
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 2,
        std: true
    },
    {
        name: "Manager",
        type: "person",
        edit: [
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 10,
        std: true
    },
    {
        name: "Group",
        type: "department",
        edit: [
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 9,
        std: true
    },
    {
        name: "Email",
        type: "email",
        edit: [
            "self",
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 3,
        std: true
    },
    {
        name: "Job Title",
        type: "text",
        edit: [
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 6,
        std: false
    },
    {
        name: "Phone Number",
        type: "phone",
        edit: [
            "self",
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 4,
        std: false
    },
    {
        name: "Hire Date",
        type: "date",
        edit: [
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 7,
        std: true
    },
    {
        name: "Role",
        type: "role",
        edit: [
            "admin"
        ],
        vis: [
            "all"
        ],
        order: 8,
        std: true
    },
    {
        name: "Termination Date",
        type: "date",
        edit: [
            "admin"
        ],
        vis: [
            "admin"
        ],
        order: 17,
        std: true
    },
    {
        name: "Login Status",
        type: "single-select",
        edit: [],
        vis: [
            "admin"
        ],
        options: [
            "Signed in",
            "Invited/ not signed in",
            "Not invited/ not signed in"
        ],
        order: 18,
        std: true
    },
    {
        name: "Contributors",
        type: "people",
        edit: [
            "admin"
        ],
        vis: [
            "admin"
        ],
        order: 22,
        std: true
    },
    {
        name: "Salary",
        type: "salary",
        edit: [
            "admin"
        ],
        vis: [
            "admin"
        ],
        order: 23,
        std: true
    }
];
const FieldValueModel = _zod.z.union([
    _zod.z.string(),
    _zod.z.date(),
    _zod.z.number(),
    _zod.z.instanceof(_bson.ObjectId),
    _zod.z.null(),
    _zod.z.array(_zod.z.string()),
    _zod.z.array(_zod.z.instanceof(_bson.ObjectId))
]);
const CustomValueModel = _zod.z.object({
    /**
	 * The id of this value.
	 */ _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    field: _zod.z.instanceof(_bson.ObjectId),
    user: _zod.z.instanceof(_bson.ObjectId),
    value: FieldValueModel,
    values: _zod.z.union([
        _zod.z.array(_zod.z.string()),
        _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
        _zod.z.array(_zod.z.number()),
        _zod.z.array(_zod.z.date()),
        _zod.z.array(_zod.z.null())
    ]),
    deleted: _zod.z.boolean().optional(),
    as_of: _zod.z.date(),
    comment: _zod.z.string().optional(),
    external_source: _zod.z.string().optional(),
    updater: _zod.z.instanceof(_bson.ObjectId).optional(),
    origin: _zod.z.string().optional()
});
const CUSTOM_FIELD_TYPES = [
    "department",
    "phone",
    "person",
    "role",
    "monetary",
    "numeric",
    "email",
    "single-select",
    "textbox",
    "text",
    "multi-select",
    "people",
    "date",
    "salary",
    "role",
    "unknown"
];
const CustomFieldTypes = _zod.z.enum(CUSTOM_FIELD_TYPES);
const CustomFieldUserClass = _zod.z.enum([
    "admin",
    "manager",
    "self",
    "all"
]);
const CustomFieldIntegration = _zod.z.record(_zod.z.string(), _zod.z.boolean()).nullable();
const CustomFieldModel = _zod.z.object({
    /**
	 * The id of this field.
	 */ _id: _zod.z.instanceof(_bson.ObjectId),
    /**
	 * The name of this field. This should be unique per company.
	 */ name: _zod.z.string(),
    /**
	 * The type of this field.
	 */ type: CustomFieldTypes,
    /**
	 * Who can view this field.
	 */ vis: _zod.z.array(CustomFieldUserClass),
    /**
	 * Who can edit this field.
	 */ edit: _zod.z.array(CustomFieldUserClass),
    /**
	 * The tags for this field. User generated.
	 */ tags: _zod.z.array(_zod.z.string()).optional(),
    /**
	 * Whether this field is a standard field.
	 */ std: _zod.z.boolean(),
    /**
	 * The company this field belongs to.
	 */ company: _zod.z.instanceof(_bson.ObjectId),
    /**
	 * The level of this field.
	 * @deprecated
	 */ level: _zod.z.enum([
        "company",
        ""
    ]).nullable(),
    /**
	 * The order of this field in the list of fields.
	 */ order: _zod.z.number(),
    /**
	 * Whether this field is deleted.
	 */ deleted: _zod.z.boolean().optional(),
    /**
	 * For single-select and multi-select fields, this is an array of options.
	 */ options: _zod.z.array(_zod.z.string()).optional(),
    /**
	 * Enabled integrations for this field.
	 */ integrations: CustomFieldIntegration.optional(),
    /**
	 * When true, this field supplies the unique external identifier used to generate
	 * synthetic emails for employees created without a valid work email. At most one
	 * field per company can hold this flag (enforced by a unique partial index).
	 */ is_alt_id: _zod.z.boolean().optional()
});
